import React from 'react'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import { doSignInWithEmailAndPassword } from '../../firebase/auth'
import Header from './Header'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
//import Footer from './Footer'
import PasswordForget from '../UserAuth/UserAccount/PasswordForget'
const styles = {
    wrapper: {
        backgroundColor: '#3f51b5',
        padding: '32px'
    },
    headline: {
        color: 'white',
        fontSize: '2em'

    },
    content: {
        color: 'white',
        maxWidth: '500px',
        margin: '16px auto 24px auto',
        fontSize: '1.1em'
    },
    errorMessage: {
        color: 'red',
        maxWidth: '500px',
        margin: '16px auto 24px auto',
        fontSize: '1.3em',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px'
    

    },
    login: {
        maxWidth: '340px',
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '16px',
        backgroundColor: 'white',
        borderRadius: '16px',
        //marginBottom: '5em'
    },
    button: {
        marginTop: '16px',
    }
    

}
class Login extends React.Component  {
    constructor(props) {
        super(props);
    
        this.state = {
            email: '',
            password: '',
            errorCode: '',
            showPasswordForget: false,
        };
      }
    handleSubmit = async (e) => {
        e.preventDefault()
        const { email, password } = this.state
        const error = await doSignInWithEmailAndPassword(email, password)
        this.setState({errorCode: error})
    }
    

    render () {
        const { errorCode, email, password } = this.state
        const isVaild = password.length<4 || email.indexOf('@')<2
        
        return (
            <div>
                <Header />
               
                <div>
                    <div style={styles.wrapper} >
                        <Typography style={styles.headline} align='center' variant='headline' gutterBottom>
                            Herzlich Willkommen
                        </Typography>
                        {errorCode===''
                            ? <Typography style={styles.content} align='center' variant='subheading' >
                                Bitte melden Sie sich mit Ihren Zugangsdaten <br/>
                                (Email Adresse und Passwort) <br/>
                                an der <strong>Vermittlungs-App</strong> an 
                              </Typography>
                            : <Typography style={styles.errorMessage} align='center' variant='subheading' >
                                <ErrorMessage error={this.state.errorCode} />
                              </Typography>
                    
                        }
                        <Paper style={styles.login}>
                            <form onSubmit={this.handleSubmit}>
                            <TextField
                                id="login_email"
                                label="E-Mail Adresse"
                                placeholder="E-Mail Adresse"
                                style={styles.input}
                                margin="normal"
                                fullWidth
                                onChange={(event)=>this.setState({email: event.target.value})}
                                value={this.state.email}
                            />
                            <TextField
                                id="login_password"
                                label="Passwort"
                                placeholder="Passwort"
                                style={styles.input}
                                margin="normal"
                                type='password'
                                onChange={event=>this.setState({password: event.target.value})}
                                fullWidth

                            />
                            <Button
                                disabled={isVaild}
                                type='submit'
                                color='primary'
                                fullWidth
                                variant='contained'
                                style={styles.button}
                            >
                                Anmelden
                            </Button>

                            </form>
                            <Button style={{margin: '12px auto 12px auto'}} fullWidth variant='outlined' color='secondary' onClick={()=>this.setState({showPasswordForget: !this.state.showPasswordForget})} >
                                Kennwort vergessen
                            </Button>
                            <section>
                            {this.state.showPasswordForget && <PasswordForget />}
                            </section>
                        </Paper>
                    </div>
                </div>
            </div>
        )
    }
}

const ErrorMessage = ({error}) => {
    let errorMessage = ''
    switch (error) {
        case 'auth/too-many-requests':
            errorMessage = 'Sie haben zu oft ein falsches Passwort eingegeben. Ihr Konto wurde gesperrt, versuchen Sie es in ein paar Minuten wieder.'
            break
        case 'auth/wrong-password':
           errorMessage = 'Sie haben ein falsches Passwort eingegeben. Bitte ändern Sie ihr Passwort.'
           break
        case 'auth/user-not-found':
          errorMessage =  'Zu dieser Email Adresse existiert kein Benutzerkonto. Überprüfen Sie ihre E-Mail Adresse.'
          break
        case 'auth/invalid-email' :
          errorMessage = 'Die E-Mail Adresse hat ein ungültiges Format. Bitte überprüfen Sie ihre E-Mail Adresse'
          break
        default:
          errorMessage = 'Es ist ein Fehler aufgetreten, bitte wenden Sie sich an die Geschäftsstelle'
       }
    return (
        <div>{errorMessage}</div>
    )
}

export default Login


// WEBPACK FOOTER //
// ./src/Components/App/Login.js